export default "__VITE_ASSET__e2b2fb0c__"